import { Driver, LoadData } from "../models";
import { Chat } from "../models/Chat";

export const dummyDrivers: Driver[] = [
  {
    id: "driver-001",
    email: "driver@email.com",
    name: "James Carter",
    phoneNumber: "+1-416-555-0101",
    route: "Toronto → Ottawa",
    assignedEquipment: {
      companyID: "company-001",
      lp: "ABC123",
      equipmentID: "eq-001",
      num: "001",
      available: true,
      trailerSubType: "Reefer",
      type: "trailer",
    },
    availability: [
      { date: "2025-06-11", startTime: "08:00", endTime: "17:00" },
      { date: "2025-06-19", startTime: "08:00", endTime: "13:00" },
      { date: "2025-06-24", startTime: "07:00", endTime: "12:00" },
      { date: "2025-06-24", startTime: "18:00", endTime: "23:00" },
    ],
  },
  {
    id: "driver-002",
    email: "driver@email.com",
    name: "Linda Nguyen",
    phoneNumber: "+1-514-555-0102",
    route: "Montreal → Quebec City",
    assignedEquipment: {
      companyID: "company-001",
      lp: "XYZ789",
      equipmentID: "eq-002",
      num: "002",
      available: true,
      trailerSubType: "DryVan",
      type: "trailer",
    },
    availability: [
      { date: "2025-06-16", startTime: "07:00", endTime: "16:00" },
      { date: "2025-06-17", startTime: "07:00", endTime: "15:00" },
      { date: "2025-06-27", startTime: "07:00", endTime: "11:00" },
    ],
  },
  {
    id: "driver-003",
    email: "driver@email.com",
    name: "Carlos Mendoza",
    phoneNumber: "+1-604-555-0103",
    route: "Vancouver → Kelowna",
    availability: [
      // { date: "2025-06-15", startTime: "09:00", endTime: "18:00" },
    ],
  },
  {
    id: "driver-004",
    email: "driver@email.com",
    name: "Sarah Thompson",
    phoneNumber: "+1-403-555-0104",
    route: "Calgary → Edmonton",
    assignedEquipment: {
      companyID: "company-001",
      lp: "LMN456",
      equipmentID: "eq-003",
      num: "003",
      available: false,
      trailerSubType: "Flatbed",
      type: "trailer",
    },
    availability: [
      { date: "2025-06-16", startTime: "10:00", endTime: "19:00" },
      { date: "2025-06-17", startTime: "08:00", endTime: "17:00" },
    ],
  },
  {
    id: "driver-005",
    email: "driver@email.com",
    name: "Mohamed Ali",
    phoneNumber: "+1-905-555-0105",
    assignedEquipment: {
      companyID: "company-002",
      lp: "JKL321",
      equipmentID: "eq-004",
      num: "004",
      available: true,
      trailerSubType: "Reefer",
      type: "boxTruck",
    },
    availability: [
      { date: "2025-06-18", startTime: "06:00", endTime: "15:00" },
    ],
  },
  {
    id: "driver-006",
    email: "driver@email.com",
    name: "Chloe Dubois",
    phoneNumber: "+1-819-555-0106",
    route: "Ottawa → Montreal",
    availability: [
      { date: "2025-06-19", startTime: "08:00", endTime: "17:00" },
      { date: "2025-06-20", startTime: "08:00", endTime: "17:00" },
    ],
  },
  {
    id: "driver-007",
    email: "driver@email.com",
    name: "Rajesh Kumar",
    phoneNumber: "+1-587-555-0107",
    assignedEquipment: {
      companyID: "company-002",
      lp: "QWE456",
      equipmentID: "eq-005",
      num: "005",
      available: true,
      trailerSubType: "DryVan",
      type: "trailer",
    },
    availability: [
      { date: "2025-06-21", startTime: "07:00", endTime: "16:00" },
    ],
  },
  {
    id: "driver-008",
    email: "driver@email.com",
    name: "Anna Petrova",
    phoneNumber: "+1-236-555-0108",
    availability: [
      { date: "2025-06-22", startTime: "09:00", endTime: "18:00" },
      { date: "2025-06-23", startTime: "09:00", endTime: "17:00" },
    ],
  },
  {
    id: "driver-009",
    email: "driver@email.com",
    name: "Liam O’Brien",
    phoneNumber: "+1-902-555-0109",
    route: "Halifax → Moncton",
    assignedEquipment: {
      companyID: "company-003",
      lp: "RTY852",
      equipmentID: "eq-006",
      num: "006",
      available: true,
      trailerSubType: "Chassis",
      type: "trailer",
    },
    availability: [
      { date: "2025-06-24", startTime: "06:00", endTime: "14:00" },
    ],
  },
  {
    id: "driver-010",
    email: "driver@email.com",
    name: "Mei Chen",
    phoneNumber: "+1-778-555-0110",
    assignedEquipment: {
      companyID: "company-003",
      lp: "RTY852",
      equipmentID: "eq-006",
      num: "006",
      available: true,
      trailerSubType: "DryVan",
      type: "trailer",
    },
    availability: [
      { date: "2025-06-25", startTime: "10:00", endTime: "19:00" },
      { date: "2025-06-26", startTime: "10:00", endTime: "19:00" },
      { date: "2025-06-26", startTime: "10:00", endTime: "19:00" },
    ],
  },
];

const driver: Driver = {
  id: "driver-001",
  name: "John Doe",
  phoneNumber: "+1 555-123-4567",
  email: "john.doe@example.com",
  availability: [],
};

// export const dummyLoads: LoadData[] = [
//   {
//     loadID: "load-001",
//     loadNumID: "L001",
//     category: "General Freight",
//     pickupLocation: {
//       name: "New York Yard",
//       address: "123 Manhattan St, NY",
//       geofencePoints: [{ lat: 40.7128, lon: -74.006 }],
//     },
//     dropOffLocation: {
//       name: "Boston Yard",
//       address: "456 Cambridge Rd, MA",
//       geofencePoints: [{ lat: 42.3601, lon: -71.0589 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-001",
//     equipmentNum: "E-1234",
//     lp: "ABC-123",
//     equipmentType: "trailer",
//     status: "unassigned",
//   },
//   {
//     loadID: "load-003",
//     loadNumID: "L003",
//     category: "Electronics",
//     pickupLocation: {
//       name: "Houston Yard",
//       address: "123 Tech Way, TX",
//       geofencePoints: [{ lat: 29.7604, lon: -95.3698 }],
//     },
//     dropOffLocation: {
//       name: "Memphis Yard",
//       address: "456 Memphis Rd, TX",
//       geofencePoints: [{ lat: 30.2672, lon: -97.7431 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-003",
//     equipmentNum: "E-9012",
//     lp: "DEF-456",
//     equipmentType: "trailer",
//     status: "assigned",
//     driver,
//   },
//   {
//     loadID: "load-002",
//     loadNumID: "L002",
//     category: "Fragile Goods",
//     pickupLocation: {
//       name: "Chicago Yard",
//       address: "789 State St, IL",
//       geofencePoints: [{ lat: 41.8781, lon: -87.6298 }],
//     },
//     dropOffLocation: {
//       name: "Detroit Yard",
//       address: "321 Motor City Ave, MI",
//       geofencePoints: [{ lat: 42.3314, lon: -83.0458 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-002",
//     equipmentNum: "E-5678",
//     lp: "XYZ-789",
//     equipmentType: "trailer",
//     status: "awaiting_pickup",
//     driver,
//   },
//   {
//     loadID: "load-003",
//     loadNumID: "L003",
//     category: "Electronics",
//     pickupLocation: {
//       name: "Houston Yard",
//       address: "123 Tech Way, TX",
//       geofencePoints: [{ lat: 29.7604, lon: -95.3698 }],
//     },
//     dropOffLocation: {
//       name: "Austin Yard",
//       address: "456 Capital Rd, TX",
//       geofencePoints: [{ lat: 30.2672, lon: -97.7431 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-003",
//     equipmentNum: "E-9012",
//     lp: "DEF-456",
//     equipmentType: "trailer",
//     status: "at_pickup_yard",
//     driver,
//   },
//   {
//     loadID: "load-004",
//     loadNumID: "L004",
//     category: "Frozen Goods",
//     pickupLocation: {
//       name: "Seattle Yard",
//       address: "789 Rainy St, WA",
//       geofencePoints: [{ lat: 47.6062, lon: -122.3321 }],
//     },
//     dropOffLocation: {
//       name: "Portland Yard",
//       address: "321 Bridge Ave, OR",
//       geofencePoints: [{ lat: 45.5152, lon: -122.6784 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-004",
//     equipmentNum: "E-3456",
//     lp: "GHI-321",
//     equipmentType: "trailer",
//     status: "checked_in_pickup",
//     driver,
//   },
//   {
//     loadID: "load-005",
//     loadNumID: "L005",
//     category: "Perishable Goods",
//     pickupLocation: {
//       name: "Phoenix Yard",
//       address: "999 Hot Blvd, AZ",
//       geofencePoints: [{ lat: 33.4484, lon: -112.074 }],
//     },
//     dropOffLocation: {
//       name: "Denver Yard",
//       address: "888 Rocky Rd, CO",
//       geofencePoints: [{ lat: 39.7392, lon: -104.9903 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-005",
//     equipmentNum: "E-7890",
//     lp: "JKL-654",
//     equipmentType: "trailer",
//     status: "loading_in_progress",
//     driver,
//   },
//   {
//     loadID: "load-006",
//     loadNumID: "L006",
//     category: "Machinery",
//     pickupLocation: {
//       name: "Los Angeles",
//       address: "456 Sunset Blvd, CA",
//       geofencePoints: [{ lat: 34.0522, lon: -118.2437 }],
//     },
//     dropOffLocation: {
//       name: "San Diego",
//       address: "321 Ocean Dr, CA",
//       geofencePoints: [{ lat: 32.7157, lon: -117.1611 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-006",
//     equipmentNum: "E-1122",
//     lp: "MNO-987",
//     equipmentType: "trailer",
//     status: "loading_completed",
//     driver,
//   },
//   {
//     loadID: "load-007",
//     loadNumID: "L007",
//     category: "Heavy Equipment",
//     pickupLocation: {
//       name: "Philadelphia",
//       address: "700 Liberty Rd, PA",
//       geofencePoints: [{ lat: 39.9526, lon: -75.1652 }],
//     },
//     dropOffLocation: {
//       name: "Baltimore",
//       address: "800 Harbor St, MD",
//       geofencePoints: [{ lat: 39.2904, lon: -76.6122 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-007",
//     equipmentNum: "E-3344",
//     lp: "PQR-000",
//     equipmentType: "trailer",
//     status: "sealed_and_ready",
//     driver,
//   },
//   {
//     loadID: "load-008",
//     loadNumID: "L008",
//     category: "General Freight",
//     pickupLocation: {
//       name: "Miami",
//       address: "123 Beach Dr, FL",
//       geofencePoints: [{ lat: 25.7617, lon: -80.1918 }],
//     },
//     dropOffLocation: {
//       name: "Orlando",
//       address: "456 Park Ave, FL",
//       geofencePoints: [{ lat: 28.5383, lon: -81.3792 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-008",
//     equipmentNum: "E-5566",
//     lp: "STU-333",
//     equipmentType: "trailer",
//     status: "in_transit",
//     driver,
//   },
//   {
//     loadID: "load-009",
//     loadNumID: "L009",
//     category: "Fragile",
//     pickupLocation: {
//       name: "Cleveland",
//       address: "500 Lakeside Ave, OH",
//       geofencePoints: [{ lat: 41.4993, lon: -81.6944 }],
//     },
//     dropOffLocation: {
//       name: "Pittsburgh",
//       address: "600 Steel St, PA",
//       geofencePoints: [{ lat: 40.4406, lon: -79.9959 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-009",
//     equipmentNum: "E-7788",
//     lp: "VWX-222",
//     equipmentType: "trailer",
//     status: "late",
//     driver,
//   },
//   {
//     loadID: "load-010",
//     loadNumID: "L010",
//     category: "Electronics",
//     pickupLocation: {
//       name: "San Jose",
//       address: "200 Tech Park, CA",
//       geofencePoints: [{ lat: 37.3382, lon: -121.8863 }],
//     },
//     dropOffLocation: {
//       name: "Sacramento",
//       address: "300 River Rd, CA",
//       geofencePoints: [{ lat: 38.5816, lon: -121.4944 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-010",
//     equipmentNum: "E-9900",
//     lp: "YZA-555",
//     equipmentType: "trailer",
//     status: "at_dropoff_yard",
//     driver,
//   },
//   {
//     loadID: "load-011",
//     loadNumID: "L011",
//     category: "Retail",
//     pickupLocation: {
//       name: "Columbus",
//       address: "400 Retail Park, OH",
//       geofencePoints: [{ lat: 39.9612, lon: -82.9988 }],
//     },
//     dropOffLocation: {
//       name: "Cincinnati",
//       address: "500 Commerce Dr, OH",
//       geofencePoints: [{ lat: 39.1031, lon: -84.512 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-011",
//     equipmentNum: "E-6677",
//     lp: "BCD-444",
//     equipmentType: "trailer",
//     status: "checked_in_dropoff",
//     driver,
//   },
//   {
//     loadID: "load-012",
//     loadNumID: "L012",
//     category: "Medical",
//     pickupLocation: {
//       name: "Nashville",
//       address: "123 Music Rd, TN",
//       geofencePoints: [{ lat: 36.1627, lon: -86.7816 }],
//     },
//     dropOffLocation: {
//       name: "Memphis",
//       address: "456 Blues St, TN",
//       geofencePoints: [{ lat: 35.1495, lon: -90.049 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-012",
//     equipmentNum: "E-2233",
//     lp: "EFG-111",
//     equipmentType: "trailer",
//     status: "unloading_in_progress",
//     driver,
//   },
//   {
//     loadID: "load-013",
//     loadNumID: "L013",
//     category: "Textiles",
//     pickupLocation: {
//       name: "Indianapolis",
//       address: "123 Fashion St, IN",
//       geofencePoints: [{ lat: 39.7684, lon: -86.1581 }],
//     },
//     dropOffLocation: {
//       name: "Louisville",
//       address: "456 Derby Ave, KY",
//       geofencePoints: [{ lat: 38.2527, lon: -85.7585 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-013",
//     equipmentNum: "E-8844",
//     lp: "HIJ-666",
//     equipmentType: "trailer",
//     status: "completed",
//     driver,
//   },
//   {
//     loadID: "load-014",
//     loadNumID: "L014",
//     category: "Hazmat",
//     pickupLocation: {
//       name: "Omaha",
//       address: "123 Cornfield Rd, NE",
//       geofencePoints: [{ lat: 41.2565, lon: -95.9345 }],
//     },
//     dropOffLocation: {
//       name: "Des Moines",
//       address: "456 Capitol Hill, IA",
//       geofencePoints: [{ lat: 41.5868, lon: -93.625 }],
//     },
//     shipper: "Dev Freight Inc.",
//     pickupTime: Date.now() / 1000,
//     dropOffTime: (Date.now() + 360000000) / 1000,
//     equipmentId: "EQ-014",
//     equipmentNum: "E-9911",
//     lp: "KLM-777",
//     equipmentType: "trailer",
//     status: "cancelled",
//     driver,
//   },
// ];

// export const dummyChats: Chat[] = [
//   {
//     id: "chat1",
//     createdAt: new Date().toISOString(),
//     participants: [
//       {
//         name: "LogiShipper Inc.",
//         role: "shipper",
//         email: "shipper1@email.com",
//         phone: "+12292202223",
//       },
//       {
//         name: "East Express Ltd.",
//         role: "carrier",
//         email: "carrier1@email.com",
//         phone: "+12292202223",
//       },
//     ],
//     loadNumber: "LOAD-0923",
//     pickupLocation: "Toronto, ON",
//     dropOffLocation: "Montreal, QC",
//     messages: [
//       {
//         id: "m1",
//         chatID: "chat1",
//         content: "We’re ready for pickup by 10AM.",
//         senderRole: "shipper",
//         date: new Date().toISOString(),
//         timestamp: Math.floor(Date.now() / 1000),
//         readers: [],
//       },
//       {
//         id: "m2",
//         chatID: "chat1",
//         content: "Great. Driver Alex will be there.",
//         senderRole: "carrier",
//         date: new Date().toISOString(),
//         timestamp: Math.floor(Date.now() / 1000),
//         readers: [],
//       },
//     ],
//   },
//   {
//     id: "chat2",
//     createdAt: new Date().toISOString(),
//     participants: [
//       {
//         name: "CargoConnect",
//         role: "shipper",
//         email: "shipper2@email.com",
//         phone: "+12292202223",
//       },
//       {
//         name: "Nova Haul",
//         role: "carrier",
//         email: "carrier2@email.com",
//         phone: "+12292202223",
//       },
//     ],
//     loadNumber: "LOAD-8347",
//     pickupLocation: "Vancouver, BC",
//     dropOffLocation: "Calgary, AB",
//     messages: [
//       {
//         id: "m1",
//         chatID: "chat2",
//         content: "Any update on driver location?",
//         senderRole: "shipper",
//         date: new Date(Date.now() - 86400000).toISOString(), // yesterday
//         timestamp: Math.floor(Date.now() / 1000),
//         readers: [],
//       },
//     ],
//   },
// ];

// export const dummyBids: Bid[] = [
//   {
//     id: "b0921",
//     amount: 1500,
//     distance: 200,
//     equipment: {
//       lp: "lp-0",
//       companyID: "N0001",
//       num: "ID-0XF1",
//       equipmentID: "eq-0",
//       type: "trailer",
//       trailerSubType: "Flatbed",
//       available: true,
//     },
//     companyName: "TransCorp Logistics",
//     driverAvailability: new Date(Date.now()).toISOString(),
//     status: "accepted",
//     loadData: {
//       pickupLocation: {
//         name: "Vancouver, BC, Canada",
//         address: "Vancouver, BC, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Calgary, AB, Canada",
//         address: "Calgary, AB, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "VAN001FK",

//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b0922",
//     amount: 1600,
//     distance: 210,
//     equipment: {
//       lp: "lp-1",
//       companyID: "N0002",
//       num: "ID-1XF2",
//       equipmentID: "eq-1",
//       type: "tractor",
//       trailerSubType: "Dry Van",
//       available: true,
//     },
//     companyName: "Maple Freight Solutions",
//     driverAvailability: new Date(Date.now() + 86400000).toISOString(),
//     status: "pending",
//     loadData: {
//       pickupLocation: {
//         name: "Montreal, QC, Canada",
//         address: "Montreal, QC, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Quebec City, QC, Canada",
//         address: "Quebec City, QC, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "MTL002FK",
//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b0923",
//     amount: 1700,
//     distance: 220,
//     equipment: {
//       lp: "lp-2",
//       companyID: "N0003",
//       num: "ID-2XF3",
//       equipmentID: "eq-2",
//       type: "boxtruck",
//       trailerSubType: "Box Truck",
//       available: true,
//     },
//     companyName: "Northern Express Co.",
//     driverAvailability: new Date(Date.now() + 2 * 86400000).toISOString(),
//     status: "rejected",
//     loadData: {
//       pickupLocation: {
//         name: "Winnipeg, MB, Canada",
//         address: "Winnipeg, MB, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Saskatoon, SK, Canada",
//         address: "Saskatoon, SK, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "WPG003FK",
//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b0924",
//     amount: 1800,
//     distance: 230,
//     equipment: {
//       lp: "lp-3",
//       companyID: "N0004",
//       num: "ID-3XF4",
//       equipmentID: "eq-3",
//       type: "trailer",
//       trailerSubType: "Refrigerated",
//       available: true,
//     },
//     companyName: "Atlantic Carriers Ltd.",
//     driverAvailability: new Date(Date.now() + 3 * 86400000).toISOString(),
//     status: "accepted",
//     loadData: {
//       pickupLocation: {
//         name: "Halifax, NS, Canada",
//         address: "Halifax, NS, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Moncton, NB, Canada",
//         address: "Moncton, NB, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "HAL004FK",
//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b0925",
//     amount: 1900,
//     distance: 240,
//     equipment: {
//       lp: "lp-4",
//       companyID: "N0005",
//       num: "ID-4XF5",
//       equipmentID: "eq-4",
//       type: "tractor",
//       trailerSubType: "Tanker",
//       available: true,
//     },
//     companyName: "Prairie Transport Inc.",
//     driverAvailability: new Date(Date.now() + 4 * 86400000).toISOString(),
//     status: "pending",
//     loadData: {
//       pickupLocation: {
//         name: "Edmonton, AB, Canada",
//         address: "Edmonton, AB, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Fort McMurray, AB, Canada",
//         address: "Fort McMurray, AB, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "EDM005FK",
//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b0926",
//     amount: 2000,
//     distance: 250,
//     equipment: {
//       lp: "lp-5",
//       companyID: "N0006",
//       num: "ID-5XF6",
//       equipmentID: "eq-5",
//       type: "boxtruck",
//       trailerSubType: "Moving Van",
//       available: true,
//     },
//     companyName: "Great Lakes Shipping",
//     driverAvailability: new Date(Date.now() + 5 * 86400000).toISOString(),
//     status: "rejected",
//     loadData: {
//       pickupLocation: {
//         name: "Thunder Bay, ON, Canada",
//         address: "Thunder Bay, ON, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Sudbury, ON, Canada",
//         address: "Sudbury, ON, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "THU006FK",
//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b0927",
//     amount: 2100,
//     distance: 260,
//     equipment: {
//       lp: "lp-6",
//       companyID: "N0007",
//       num: "ID-6XF7",
//       equipmentID: "eq-6",
//       type: "trailer",
//       trailerSubType: "Lowboy",
//       available: true,
//     },
//     companyName: "Rockies Freight Corp.",
//     driverAvailability: new Date(Date.now() + 6 * 86400000).toISOString(),
//     status: "accepted",
//     loadData: {
//       pickupLocation: {
//         name: "Prince George, BC, Canada",
//         address: "Prince George, BC, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Kamloops, BC, Canada",
//         address: "Kamloops, BC, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "PGE007FK",
//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b0928",
//     amount: 2200,
//     distance: 270,
//     equipment: {
//       lp: "lp-7",
//       companyID: "N0008",
//       num: "ID-7XF8",
//       equipmentID: "eq-7",
//       type: "tractor",
//       trailerSubType: "Car Carrier",
//       available: true,
//     },
//     companyName: "Maritime Movers Ltd.",
//     driverAvailability: new Date(Date.now() + 7 * 86400000).toISOString(),
//     status: "pending",
//     loadData: {
//       pickupLocation: {
//         name: "St. John's, NL, Canada",
//         address: "St. John's, NL, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Corner Brook, NL, Canada",
//         address: "Corner Brook, NL, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "STJ008FK",
//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b0929",
//     amount: 2300,
//     distance: 280,
//     equipment: {
//       lp: "lp-8",
//       companyID: "N0009",
//       num: "ID-8XF9",
//       equipmentID: "eq-8",
//       type: "boxtruck",
//       trailerSubType: "Delivery Van",
//       available: true,
//     },
//     companyName: "Arctic Haulers Inc.",
//     driverAvailability: new Date(Date.now() + 8 * 86400000).toISOString(),
//     status: "rejected",
//     loadData: {
//       pickupLocation: {
//         name: "Yellowknife, NT, Canada",
//         address: "Yellowknife, NT, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Whitehorse, YT, Canada",
//         address: "Whitehorse, YT, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "YEL009FK",
//       loadNumID: "numID",
//     },
//   },
//   {
//     id: "b09210",
//     amount: 2400,
//     distance: 290,
//     equipment: {
//       lp: "lp-9",
//       companyID: "N0010",
//       num: "ID-9XFA",
//       equipmentID: "eq-9",
//       type: "trailer",
//       trailerSubType: "Step Deck",
//       available: true,
//     },
//     companyName: "Dominion Logistics Group",
//     driverAvailability: new Date(Date.now() + 9 * 86400000).toISOString(),
//     status: "accepted",
//     loadData: {
//       pickupLocation: {
//         name: "Regina, SK, Canada",
//         address: "Regina, SK, Canada",
//         geofencePoints: [],
//       },
//       dropOffLocation: {
//         name: "Brandon, MB, Canada",
//         address: "Brandon, MB, Canada",
//         geofencePoints: [],
//       },
//       dropOffTime: 1754006399,
//       pickupTime: 1751328000,
//       loadID: "REG010FK",
//       loadNumID: "numID",
//     },
//   },
// ];
